import { callProcedure } from 'core/classes/helpers/callProcedure'
import { IFetchDataFn } from 'partner360/widgets/assortmentTab/context/models/IFetchDataFn'

import { IAssortmentItem } from '../models/data/IAssortmentItem'

export const fetchAssortmentItems: IFetchDataFn<IAssortmentItem> = async ({
  partnerId,
  fYear,
  programType,
  category,
}) => {
  try {
    const data: IAssortmentItem[] = await callProcedure('spJBPAssortment', {
      'p.PartnerID': partnerId,
      'p.FYear': fYear,
      'p.ProgramType': programType,
      'p.Category': category,
    })

    return data.sort((a, b) => a.SortOrder - b.SortOrder)
  } catch (e) {
    return []
  }
}
